import {Component, Input, OnInit} from '@angular/core';

const LUCIDE_ICON_MAP: { [fontClass: string]: string } = {
  'icon-arrow-left': 'arrow-left',
  'icon-trash': 'trash-2',
  'icon-pencil': 'pencil',
  'icon-edit': 'pencil',
  'icon-lock': 'lock',
  'icon-unlink': 'unlink',
  'icon-team': 'users',
  'icon-star-full': 'star',
  'icon-restore': 'archive-restore',
  'icon-fired': 'user-x',
  'icon-chart-small': 'chart-column',
  'icon-task': 'list-checks',
  'icon-hat': 'graduation-cap',
  'icon-preview': 'eye',
  'icon-link': 'link',
  'icon-invited-users': 'mail',
  'icon-close': 'x',
  'icon-document': 'file-text',
};

@Component({
  selector: 'ui-popup-menu-item',
  templateUrl: './ui-popup-menu-item.component.html',
  styleUrls: ['./ui-popup-menu-item.component.less']
})
export class UiPopupMenuItemComponent implements OnInit {
  @Input() iconName: string;

  // Имя иконки lucide, если для входного класса есть маппинг
  lucideName: string | null = null;
  // Остальные классы (цвет/раскладка) — пробрасываем как есть на иконку
  extraClass: string[] = [];

  constructor() { }

  ngOnInit() {
    const classes = (this.iconName || '').split(/\s+/).filter(Boolean);
    classes.forEach((cls) => {
      if (LUCIDE_ICON_MAP[cls]) {
        this.lucideName = LUCIDE_ICON_MAP[cls];
      } else {
        this.extraClass.push(cls);
      }
    });
  }

}
